import {Cover} from "../../task/properties/cover";

export class GoalProperties {

    public cover?           : Cover

    constructor(data:any = {}) {
        const cover = _.get(data,'cover', undefined)
        if (cover) this.cover = new Cover(cover)
    }


    toJSON() {
        const result: any = {}

        if (this.cover) {
            result.cover = this.cover.toJSON()
        }

        return result
    }
}